/* v8 ignore start */
import type { TemplateRef } from '@angular/core';
import { Directive, Input } from '@angular/core';
/**
 * Used for Storybook to prevent errors cannot find directive
 */
@Directive({
	selector: 'vp-tab-menu-item, [vp-tab-menu-item], [vpTabMenuItem]',
})
export class TabMenuItemDirective {
	@Input({ required: true }) label = '';
	@Input({ required: true }) name = '';
	@Input() content: TemplateRef<unknown> | null = null;
}
/* v8 ignore stop */
